module.exports = __webpack_public_path__ + "img/opet-infographic-06.68a869ac.jpg";